import React, { useEffect } from "react";
import { getCommunityChats } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const ChatsCommunities = ({ getCommunityChats, communityChats, period }) => {
  useEffect(() => {
    getCommunityChats({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityChats(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityChats(payload);
  };

  return (
    <DataTable
      preset="chatsCommunities"
      data={{
        docs: communityChats?.docs || [],
        totalPages: communityChats?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityChats: state.appCommunities.communityChats,
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityChats: (payload) => dispatch(getCommunityChats(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatsCommunities);
